import React, { useEffect, useState } from "react";
import axios from "axios";
import { ClientConfiguration } from "aws-sdk/clients/s3";
import AWS from "aws-sdk";

import { AWSCredentialResponseModel } from "../../Models/devices";
import { getCloudVideoCredential } from "../../API/apiAuth";

export function useS3() {
  const [loadingCredentials, setLoadingCredentials] = useState(false);
  const [credentialCloudStorage, setCredentialCloudStorage] =
    useState<AWSCredentialResponseModel>();
  const [s3, setS3] = useState<AWS.S3>();
  const [s3Ready, setS3Ready] = useState<boolean>(false);

  useEffect(() => {
    const source = axios.CancelToken.source();

    const loadCredentialsStorage = async () => {
      try {
        setLoadingCredentials(true);
        const response = await getCloudVideoCredential(source.token);
        if (!response.data.hasErrors) {
          setCredentialCloudStorage(response.data.payload);
        }
      } catch (error) {
        //
      } finally {
        setLoadingCredentials(false);
      }
    };

    loadCredentialsStorage();
  }, []);

  useEffect(() => {
    if (!credentialCloudStorage) {
      return;
    }

    const awsConfig: ClientConfiguration = {
      region: process.env.REACT_APP_CloudStorange_Region,
      credentials: {
        accessKeyId: credentialCloudStorage?.credential.accessKeyId as string,
        secretAccessKey: credentialCloudStorage?.credential.secretAccessKey as string,
        sessionToken: credentialCloudStorage?.credential.sessionToken,
      },
      endpoint: process.env.REACT_APP_CloudStorange_URL,
      s3ForcePathStyle: true,
    };

    setS3(new AWS.S3(awsConfig));
    setS3Ready(true);
  }, [credentialCloudStorage]);

  return { s3, s3Ready };
}
